import React from 'react';

import { RecommendationBasicPage } from './component/RecommendationBasicPage/RecommendationBasicPage';

export const RecommendationPage = ({ teamBuilding }: { teamBuilding: boolean }) => (
  <RecommendationBasicPage teamBuilding={teamBuilding} />
);
